import { useCallback, useMemo } from 'react';
import * as events from 'src/lib/events';
import { useCustomerActions, useUserActions } from 'src/store';

export const useEvents = () => {
  const customerActions = useCustomerActions();
  const userActions = useUserActions();

  const trackCloseClick = useCallback(() => {
    events.trackEvent(events.PROJECT.clickedScoreHintClose, {
      customerId: customerActions.getCurrentCustomerId(),
      userId: userActions.getCurrentUser().id,
    });
  }, [customerActions, userActions]);

  const trackDontShowAgainChecked = useCallback(
    (checked) => {
      events.trackEvent(events.PROJECT.checkedScoreHintDontShow, {
        customerId: customerActions.getCurrentCustomerId(),
        userId: userActions.getCurrentUser().id,
        checked,
      });
    },
    [customerActions, userActions]
  );

  return useMemo(
    () => ({
      trackCloseClick,
      trackDontShowAgainChecked,
    }),
    [trackCloseClick, trackDontShowAgainChecked]
  );
};
